import { useTranslation } from "react-i18next";
import { Page } from "@/components/Page";
import { DefinitionList, PageSection } from "@/components/section/SectionBlocks";
import { SectionLoading } from "@/components/section/SectionStates";
import { Text } from "@/components/Text";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { formatDate } from "@/i18n/format";
import { ProfileSummary } from "./ProfileSummary";

const ROLES = ["member", "platform_admin", "install_admin"] as const;
type KnownRole = (typeof ROLES)[number];
const isKnownRole = (role: string): role is KnownRole => (ROLES as readonly string[]).includes(role);

export function ProfilePage() {
  const { t } = useTranslation("settings");
  const me = useCurrentUser();
  const user = me.data?.user;
  return (
    <Page title={t("profile.title")} subtitle={t("profile.subtitle")}>
      {user ? (
        <>
          <ProfileSummary />
          <PageSection title={t("profile.account")}>
            <DefinitionList
              items={[
                { label: t("profile.name"), value: user.name },
                { label: t("profile.email"), value: user.email },
                {
                  label: t("profile.role"),
                  value: isKnownRole(user.role) ? t(`profile.roles.${user.role}`) : user.role,
                },
                { label: t("profile.memberSince"), value: formatDate(user.createdAt) },
              ]}
            />
            <Text variant="body-sm" tone="tertiary">
              {t("profile.synced")}
            </Text>
          </PageSection>
        </>
      ) : (
        <SectionLoading rows={2} />
      )}
    </Page>
  );
}
